import type { CSSProperties } from 'react';

export interface JournalEntryCardProps {
  weekday: string;
  dayNumber: number;
  title: string;
  body: string;
  time: string;
  chipColor?: string;
  chipLabel: string;
}

export function JournalEntryCard({
  weekday,
  dayNumber,
  title,
  body,
  time,
  chipColor = '#018B9C',
  chipLabel,
}: JournalEntryCardProps) {
  const chipStyle = { '--mk-chip': chipColor } as CSSProperties;

  return (
    <div className='mk-journal'>
      <div className='mk-journal__date'>
        <span className='mk-journal__weekday'>{weekday}</span>
        <span className='mk-journal__day'>{dayNumber}</span>
      </div>
      <div className='mk-journal__body'>
        <p className='mk-journal__title'>{title}</p>
        <p className='mk-journal__text'>{body}</p>
        <div className='mk-journal__meta'>
          <span className='mk-journal__time'>{time}</span>
          <span className='mk-journal__chip' style={chipStyle}>
            <i className='mk-journal__chip-dot' />
            {chipLabel}
          </span>
        </div>
      </div>
    </div>
  );
}
